<div class="container single-view" id="view-code-order">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/code-orders" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CODE_ORDERS.BTN_BACK_TO_CODE_ORDER' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="order-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'CODE_ORDERS.CODE_ORDER_DETAILS' | translate }}
            </h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (codeOrder.id) {
                  <span data-testid='order-name'>{{ 'CODE_ORDER_SINGLE_VIEW.ORDER' | translate }} #{{ codeOrder.id | defaultValue }}</span>
                }
                @if (codeOrder.state) {
<span data-testid='order-state' class="tag" [ngClass]="{
                  'tag-gray': codeOrder.state === codeOrderState.CODE_ORDER_REQUESTED,
                  'tag-orange': codeOrder.state === codeOrderState.CODE_ORDER_IN_PROGRESS,
                  'tag-blue': codeOrder.state === codeOrderState.CODE_ORDER_PROCESSED,
                  'tag-green': codeOrder.state === codeOrderState.CODE_ORDER_DOWNLOADED,
                  'tag-red': codeOrder.state === codeOrderState.CODE_ORDER_FAILED}">
                    {{ codeOrder.state | orderState }}
                  </span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="w-100 flex flex-wrap justify-between gap-y-4">
          <div id="complementary-details" class="flex flex-wrap">
            <span data-testid='order-company' class="flex items-center mr-2" pTooltip="{{ 'CODE_ORDER_SINGLE_VIEW.TOOLTIP_COMPANY' | translate }}" tooltipPosition="top"><i class="icon icon-company mr-1"></i>
            {{ codeOrder.companyName | defaultValue }}
          </span>
          <span data-testid='order-createdon' class="flex items-center mr-2"
            pTooltip="{{ 'CODE_ORDER_SINGLE_VIEW.TOOLTIP_REQUEST_DATE' | translate }}" tooltipPosition="top"><i class="icon icon-calendar-tick mr-1"></i>
            {{ codeOrder.createdOn | date: 'dd-MM-yyyy HH:mm' | defaultValue }}
          </span>
        </div>
        <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3 mt-2">
          @if (allowDownloadOrder) {
            <button data-testid='order-download-btn' id="btn-download-order" class="btn primary-btn" [ngClass]="{'disabled': isDownloadDisabled()}" [disabled]="isDownloadDisabled()" (click)="downloadCodeOrderFile()">{{ 'CODE_ORDERS.DOWNLOAD_FILE' | translate }}</button>
          }
        </div>
      </div>
    </div>
    <hr role="presentation" class="w-full mb-3 mt-6 border-t">
    <div class="view-content-wr">
      <div class="row">
        <div class="flex flex-col col-12 mb-2 text-wr">
          <!-- main content -->
          <section class="row">
            <div class="col-12">
              <h4 data-testid='inventory-summary'>{{ 'CODE_ORDER_SINGLE_VIEW.DETAILS' | translate }}</h4>
              <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              <dl class="details-grid">

                <dt data-testid='order-company-label' class="label grid-cols-1 pt-3">{{ 'CODE_ORDER_SINGLE_VIEW.COMPANY' | translate }}</dt>
                <dd data-testid='order-company' class="value pt-3 pb-3">{{ codeOrder.companyName | defaultValue }}</dd>

                <dt data-testid='order-type-label' class="label grid-cols-1 pt-3">{{ 'CODE_ORDER_SINGLE_VIEW.TYPE' | translate }}</dt>
                <dd data-testid='order-type' class="value pt-3 pb-3">{{ codeOrder.codeType | orderGenerationType | defaultValue }}</dd>

                <dt data-testid='order-quantity-label' class="label grid-cols-1 pt-3">{{ 'CODE_ORDER_SINGLE_VIEW.QUANTITY' | translate }}</dt>
                <dd data-testid='order-quantity' class="value pt-3 pb-3">{{ codeOrder.quantity | defaultValue }}</dd>

                <dt data-testid='order-algorithm-label' class="label grid-cols-1 pt-3">{{ 'CODE_ORDER_SINGLE_VIEW.ALGORITHM' | translate }}</dt>
                <dd data-testid='order-algorithm' class="value pt-3 pb-3">{{ codeOrder.algorithmType | orderGenerationAlgorithm | defaultValue }}</dd>

                <dt data-testid='order-output-label' class="label grid-cols-1 pt-3">{{ 'CODE_ORDER_SINGLE_VIEW.OUTPUT_FORMAT' | translate }}</dt>
                <dd data-testid='order-output' class="value pt-3 pb-3">{{ codeOrder.outputFormatType | orderOutputFormat | defaultValue }}</dd>

                @if (codeOrder.productName) {
                  <dt data-testid='order-product-label' class="label grid-cols-1 pt-3">{{ 'CODE_ORDER_SINGLE_VIEW.PRODUCT' | translate }}</dt>
                }
                @if (codeOrder.productName) {
                  <dd data-testid='order-product' class="value pt-3 pb-3">
                    @if (allowViewProduct) {
                      <a [routerLink]="['/products/', codeOrder.productId]" class="inline-flex items-center link">{{ codeOrder.productName | defaultValue }}</a>
                    } @else {
                      {{ codeOrder.productName | defaultValue }}
                    }
                  </dd>
                }

                <dt data-testid='order-requestedby-label' class="label grid-cols-1 pt-3">{{ 'CODE_ORDER_SINGLE_VIEW.REQUESTED_BY' | translate }}</dt>
                <dd data-testid='order-requestedby' class="value pt-3 pb-3">
                  @if (codeOrder.createdById && allowViewUser) {
                    <a [routerLink]="['/users/', codeOrder.createdById]" class="inline-flex items-center link">{{ codeOrder.createdByFullName | defaultValue }}</a>
                  } @else {
                    {{ codeOrder.createdByFullName | defaultValue }}
                  }
                </dd>

                <dt data-testid='order-requesteddate-label' class="label grid-cols-1 pt-3">{{ 'CODE_ORDER_SINGLE_VIEW.REQUEST_DATE' | translate }}</dt>
                <dd data-testid='order-requesteddate' class="value pt-3 pb-3">{{ codeOrder.createdOn | date: 'dd-MM-yyyy HH:mm' }}</dd>
              </dl>
            </div>

          </section>
          <!-- /main content -->
        </div>
      </div>
    </div>
  </div>
</div>
</div>
